import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

const RemoveRankPlayerDialog = ({
  open,
  playerName,
  loading,
  errorMessage,
  onClose,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onClose}
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle sx={{ fontWeight: 700 }}>Remover jogador do ranking?</DialogTitle>
    <DialogContent>
      <Stack spacing={1.5}>
        <Typography variant="body2" color="text.secondary">
          Tem certeza de que deseja remover{" "}
          <strong>{playerName || "este jogador"}</strong> deste ranking?
        </Typography>
        <Alert severity="warning">
          Ao remover este jogador, os dados relacionados à participação dele
          neste ranking poderão ser excluídos, incluindo partidas, resultados,
          pontuação, saldo e demais vínculos. Esta ação não poderá ser desfeita.
        </Alert>
        {errorMessage ? (
          <Alert severity="error">{errorMessage}</Alert>
        ) : null}
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        Voltar
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={onConfirm}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {loading ? "Removendo..." : "Remover jogador"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default RemoveRankPlayerDialog;
